import { GetterTree } from 'vuex'

import { RootState, UserState } from '@/types/store'

export interface UserGetters extends GetterTree<UserState, RootState> {
  user: (state: UserState) => UserState['user']
}

export const getters: UserGetters = {
  user(state): UserState['user'] {
    return state.user
  },
}
